export const buildEventSource = url => {
  return new EventSource(url);
};
